import axios, { AxiosError } from "axios";
import toast from "react-hot-toast";
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
const api = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
});
let showToast = true;

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      if (showToast) {
        toast.error("Sesi anda telah habis. Mohon untuk melakukan login ulang");
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000);
        showToast = false;
      }
    }
    return Promise.reject(error);
  },
);
export default api;
